<template>
    <transition name="slide">
        <div v-if="showHelpText" :id="helpTextId" class="help-text mt-4">
            {{ helpText }}
            <a
            @click="handleFaqClick()"
            class="underline text-green faq-link"
            :href="faqNumber"
            ><b>FAQ's</b>
            </a>
        </div>
    </transition>
</template>

<script>
    import { faqLinkClick } from '../../assets/js/form';
    export default {
        props: {
            signPostId: {
            type: String,
            default: null,
            },
        },
        computed: {
            // get faq id used to target a specific faq answer
            faqNumber(){
                return `#faq-${this.getFaqNumber()}`;
            },
            // get bool value on whether to show the signpost component or not
            showHelpText() {
                return [
                    'debt_consolidation',
                    'student',
                    'unemployed',
                    'benefits_and_fulltime',
                    'benefits_and_parttime',
                    'benefits',
                    'dob',
                    'ratio',
                    'housing',
                ].includes(this.signPostId);
            },
            // get id for the help text signpost
            helpTextId() {
                return `help-text-${this.signPostId}`;
            },
            // get the custom help text by signpost id
            helpText() {
            const helpTextMap = {
                debt_consolidation: "If you're struggling with debt, see our",
                student: 'Lenders are less likely to accept customers who are students without regular income from employment, please see our',
                unemployed: 'Lenders are unlikely to accept customers who are unemployed. If you\'re struggling with debt, see our',
                benefits_and_fulltime: 'Lenders are unlikely to accept customers who are on benefits. If you\'re struggling with debt, see our',
                benefits_and_parttime: 'Lenders are unlikely to accept customers who are on benefits. If you\'re struggling with debt, see our',
                benefits: 'Lenders are unlikely to accept customers who are on benefits. If you\'re struggling with debt, see our',
                dob: 'Lenders use eligibility criteria to assess credit applications which can include your age, for more information please see our',
                ratio: 'The loan amount you\'re looking to borrow is high when you take into consideration your age and total annual income.',
                housing: 'It looks like your mortgage payment might be lower than expected. Please check the amount reflects any payments you have.',
            };
            return helpTextMap[this.signPostId] || '';
            },
        },
        methods: {
            // handle click of the link in the vulnerable customer sign posting
            handleFaqClick() {
                faqLinkClick(this.faqNumber, this.helpText);
            },
            // map signpost id with the target faq-answer id
            getFaqNumber() {
            const faqNumberMap = {
                debt_consolidation: 9,
                unemployed: 8,
                student: 7,
                benefits_and_fulltime: 6,
                benefits_and_parttime: 6, 
                benefits: 6,
                ratio: 5,
                dob: 1,
                housing: 1,
            };
            return faqNumberMap[this.signPostId] || '';
            },
        },
    };
</script>

<style lang="scss" scoped>
</style>